// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 24qDGfvb2rMn6oy8PVF95d
// Component: qgkS2GV7Eb

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";

import { ThemeValue, useTheme } from "./PlasmicGlobalVariant__Theme"; // plasmic-import: 40N_XXvhaC/globalVariant

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import plasmic_plasmic_rich_components_css from "../plasmic_rich_components/plasmic_plasmic_rich_components.module.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss
import plasmic_pro_pro_css from "../pro_pro/plasmic_pro_pro.module.css"; // plasmic-import: qtWvXH8Uhh67sc1TY2MZeK/projectcss
import projectcss from "./plasmic_hub_hub.module.css"; // plasmic-import: 24qDGfvb2rMn6oy8PVF95d/projectcss
import sty from "./PlasmicEditIcon.module.css"; // plasmic-import: qgkS2GV7Eb/css

import Vector18Icon from "./icons/PlasmicIcon__Vector18"; // plasmic-import: okl9tliOZv/icon

createPlasmicElementProxy;

export type PlasmicEditIcon__VariantMembers = {
  vertical: "vertical";
  color: "blue" | "red";
  sectionSettings: "sectionSettings";
};
export type PlasmicEditIcon__VariantsArgs = {
  vertical?: SingleBooleanChoiceArg<"vertical">;
  color?: SingleChoiceArg<"blue" | "red">;
  sectionSettings?: SingleBooleanChoiceArg<"sectionSettings">;
};
type VariantPropType = keyof PlasmicEditIcon__VariantsArgs;
export const PlasmicEditIcon__VariantProps = new Array<VariantPropType>(
  "vertical",
  "color",
  "sectionSettings"
);

export type PlasmicEditIcon__ArgsType = {};
type ArgPropType = keyof PlasmicEditIcon__ArgsType;
export const PlasmicEditIcon__ArgProps = new Array<ArgPropType>();

export type PlasmicEditIcon__OverridesType = {
  root?: p.Flex<"div">;
  line1?: p.Flex<"svg">;
  blueCircles?: p.Flex<typeof p.PlasmicImg>;
  img?: p.Flex<typeof p.PlasmicImg>;
  redCircles?: p.Flex<typeof p.PlasmicImg>;
  line2?: p.Flex<"svg">;
};

export interface DefaultEditIconProps {
  vertical?: SingleBooleanChoiceArg<"vertical">;
  color?: SingleChoiceArg<"blue" | "red">;
  sectionSettings?: SingleBooleanChoiceArg<"sectionSettings">;
  className?: string;
}

const $$ = {};

function PlasmicEditIcon__RenderFunc(props: {
  variants: PlasmicEditIcon__VariantsArgs;
  args: PlasmicEditIcon__ArgsType;
  overrides: PlasmicEditIcon__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  const stateSpecs: Parameters<typeof p.useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "vertical",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.vertical
      },
      {
        path: "color",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.color
      },
      {
        path: "sectionSettings",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.sectionSettings
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  const globalVariants = ensureGlobalVariants({
    theme: useTheme()
  });

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        plasmic_plasmic_rich_components_css.plasmic_tokens,
        plasmic_pro_pro_css.plasmic_tokens,
        sty.root,
        {
          [projectcss.global_theme_dark]: hasVariant(
            globalVariants,
            "theme",
            "dark"
          ),
          [sty.rootglobal_theme_dark]: hasVariant(
            globalVariants,
            "theme",
            "dark"
          ),
          [sty.rootsectionSettings]: hasVariant(
            $state,
            "sectionSettings",
            "sectionSettings"
          ),
          [sty.rootvertical]: hasVariant($state, "vertical", "vertical")
        }
      )}
    >
      {(
        hasVariant($state, "sectionSettings", "sectionSettings") ? false : true
      ) ? (
        <Vector18Icon
          data-plasmic-name={"line1"}
          data-plasmic-override={overrides.line1}
          className={classNames(projectcss.all, sty.line1, {
            [sty.line1global_theme_light]: hasVariant(
              globalVariants,
              "theme",
              "light"
            ),
            [sty.line1sectionSettings]: hasVariant(
              $state,
              "sectionSettings",
              "sectionSettings"
            )
          })}
          role={"img"}
        />
      ) : null}
      {(
        hasVariant($state, "sectionSettings", "sectionSettings")
          ? false
          : hasVariant($state, "color", "red")
          ? false
          : true
      ) ? (
        <p.PlasmicImg
          data-plasmic-name={"blueCircles"}
          data-plasmic-override={overrides.blueCircles}
          alt={""}
          className={classNames(sty.blueCircles, {
            [sty.blueCirclescolor_blue]: hasVariant($state, "color", "blue"),
            [sty.blueCirclescolor_red]: hasVariant($state, "color", "red"),
            [sty.blueCirclesglobal_theme_dark]: hasVariant(
              globalVariants,
              "theme",
              "dark"
            ),
            [sty.blueCirclesglobal_theme_light]: hasVariant(
              globalVariants,
              "theme",
              "light"
            ),
            [sty.blueCirclessectionSettings]: hasVariant(
              $state,
              "sectionSettings",
              "sectionSettings"
            ),
            [sty.blueCirclesvertical]: hasVariant(
              $state,
              "vertical",
              "vertical"
            )
          })}
          displayHeight={"1.25em"}
          displayMaxHeight={"none"}
          displayMaxWidth={"100%"}
          displayMinHeight={"0"}
          displayMinWidth={"0"}
          displayWidth={"auto"}
          loader={"plasmic"}
          loading={"lazy"}
          src={{
            src: "https://site-assets.plasmic.app/21f25acf6d6259ccc3f883a7a4388c04.svg",
            fullWidth: 23,
            fullHeight: 20,
            aspectRatio: 1.15
          }}
        />
      ) : null}
      <p.PlasmicImg
        data-plasmic-name={"img"}
        data-plasmic-override={overrides.img}
        alt={""}
        className={classNames(sty.img, {
          [sty.imgsectionSettings]: hasVariant(
            $state,
            "sectionSettings",
            "sectionSettings"
          )
        })}
        displayHeight={"auto"}
        displayMaxHeight={"none"}
        displayMaxWidth={
          hasVariant($state, "sectionSettings", "sectionSettings")
            ? "160%"
            : "100%"
        }
        displayMinHeight={"0"}
        displayMinWidth={"0"}
        displayWidth={
          hasVariant($state, "sectionSettings", "sectionSettings")
            ? "160%"
            : "auto"
        }
        loader={"plasmic"}
        loading={"lazy"}
        src={
          hasVariant($state, "sectionSettings", "sectionSettings")
            ? {
                src: "https://img.plasmic.app/img-optimizer/v1/img/77e39ca45457eb320d5ae833f86edba8.png",
                fullWidth: 338,
                fullHeight: 365
              }
            : {
                src: "https://img.plasmic.app/img-optimizer/v1/img/e0725086c7ae74d6e62500412c4082ad.png",
                fullWidth: 169,
                fullHeight: 183
              }
        }
      />

      {(hasVariant($state, "color", "red") ? true : false) ? (
        <p.PlasmicImg
          data-plasmic-name={"redCircles"}
          data-plasmic-override={overrides.redCircles}
          alt={""}
          className={classNames(sty.redCircles, {
            [sty.redCirclescolor_red]: hasVariant($state, "color", "red")
          })}
          displayHeight={"20px"}
          displayMaxHeight={"none"}
          displayMaxWidth={"100%"}
          displayMinHeight={"0"}
          displayMinWidth={"0"}
          displayWidth={"23px"}
          loader={"plasmic"}
          loading={"lazy"}
          src={{
            src: "https://site-assets.plasmic.app/6e7c3a3c60eb46af214373e1fb9991da.svg",
            fullWidth: 23,
            fullHeight: 20,
            aspectRatio: 1.15
          }}
        />
      ) : null}
      {(
        hasVariant($state, "sectionSettings", "sectionSettings") ? false : true
      ) ? (
        <Vector18Icon
          data-plasmic-name={"line2"}
          data-plasmic-override={overrides.line2}
          className={classNames(projectcss.all, sty.line2, {
            [sty.line2global_theme_light]: hasVariant(
              globalVariants,
              "theme",
              "light"
            ),
            [sty.line2sectionSettings]: hasVariant(
              $state,
              "sectionSettings",
              "sectionSettings"
            )
          })}
          role={"img"}
        />
      ) : null}
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "line1", "blueCircles", "img", "redCircles", "line2"],
  line1: ["line1"],
  blueCircles: ["blueCircles"],
  img: ["img"],
  redCircles: ["redCircles"],
  line2: ["line2"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  line1: "svg";
  blueCircles: typeof p.PlasmicImg;
  img: typeof p.PlasmicImg;
  redCircles: typeof p.PlasmicImg;
  line2: "svg";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicEditIcon__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicEditIcon__VariantsArgs;
    args?: PlasmicEditIcon__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicEditIcon__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicEditIcon__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicEditIcon__ArgProps,
          internalVariantPropNames: PlasmicEditIcon__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicEditIcon__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicEditIcon";
  } else {
    func.displayName = `PlasmicEditIcon.${nodeName}`;
  }
  return func;
}

export const PlasmicEditIcon = Object.assign(
  // Top-level PlasmicEditIcon renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    line1: makeNodeComponent("line1"),
    blueCircles: makeNodeComponent("blueCircles"),
    img: makeNodeComponent("img"),
    redCircles: makeNodeComponent("redCircles"),
    line2: makeNodeComponent("line2"),

    // Metadata about props expected for PlasmicEditIcon
    internalVariantProps: PlasmicEditIcon__VariantProps,
    internalArgProps: PlasmicEditIcon__ArgProps
  }
);

export default PlasmicEditIcon;
/* prettier-ignore-end */
